import { createAsyncThunk } from "@reduxjs/toolkit";
import { PAGINATION_COUNT_STEP_THREE } from "constant";
import { $api } from "libs/axios";
import { kiiEnumsAPI } from "libs/apiClient/KiiEnums";

export const createEnumList = createAsyncThunk(
	"stepThreeSlice/createEnumList",
	async (
		{
			organizationId,
			listName,
			selectionList,
			close,
		}: { organizationId: number; listName: string; selectionList: any[]; close: () => void },
		{ rejectWithValue },
	) => {
		try {
			const selectionListId: number[] = selectionList.map((object: any) => object.id);
			const newEnumList = await kiiEnumsAPI.addNewMainEnumListCreate(organizationId, listName).then((r) => r.data);
			await kiiEnumsAPI.addObjlistToEnumListCreate(newEnumList.id, selectionListId).then((r) => r.data);
			close();
			return { newEnumList };
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getAvailableObjectList = createAsyncThunk(
	"stepThreeSlice/getAvailableObjectList",
	async ({ organizationId, enumListId }: { organizationId: number; enumListId?: number }, { rejectWithValue }) => {
		try {
			return await kiiEnumsAPI
				.selectionListDetail(organizationId, {
					...(enumListId && { enumListId }),
				})
				.then((r) => r.data);
			// return (
			// 	await $api<any[]>(`/kii_enums/${organizationId}/selection_list${enumListId ? `?enumListId=${enumListId}` : ""}`)
			// ).data;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const createDeadline = createAsyncThunk(
	"stepThreeSlice/createDeadline",
	async (
		{ objectId, date, deactivateStatus }: { objectId: number; date: string; deactivateStatus: () => void },
		{ rejectWithValue },
	) => {
		try {
			await kiiEnumsAPI.setPlanDateCreate(objectId, date);
			// await $api.post<any[]>(`/kii_enums/${objectId}/${date}/set_plan_date`);
			deactivateStatus();
			return { objectId, date };
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

// готов
export const deleteObject = createAsyncThunk(
	"stepThreeSlice/deleteObject",
	async (
		{
			objectId,
			enumListId,
			part,
			quantity,
			deactivateStatus,
		}: { objectId: number; enumListId: number; part: number | null; quantity: number; deactivateStatus: () => void },
		{ rejectWithValue },
	) => {
		try {
			await kiiEnumsAPI.deleteCreate([objectId]);
			// await $api.post<any[]>(`/kii_enums/delete`, [objectId]);
			let response: any[] = [];
			if (part) {
				response = await kiiEnumsAPI
					.enumObjsDetail(enumListId, {
						offset: part,
						limit: quantity,
						short_info: false,
					})
					.then((r) => r.data);
				// response = (
				// 	await $api<any[]>(`/kii_enums/${enumListId}/enum_objs?offset=${part}&limit=${quantity}&short_info=${false}`)
				// ).data;
			}
			deactivateStatus();
			return { objectId, newObject: response[response.length - 1] };
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getMainEnumList = createAsyncThunk(
	"stepThreeSlice/getMainEnumList",
	async (organizationId: number, { rejectWithValue }) => {
		try {
			return await kiiEnumsAPI.mainEnumListDetail(organizationId).then((r) => r.data);
			// return (await $api<any[]>(`/kii_enums/${organizationId}/main_enum_list`)).data;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getAllEnumList = createAsyncThunk(
	"stepThreeSlice/getAllEnumList",
	async (organizationId: number, { rejectWithValue }) => {
		try {
			return await kiiEnumsAPI.allEnumListDetail(organizationId).then((r) => r.data);
			// return (await $api<any[]>(`/kii_enums/${organizationId}/all_enum_list`)).data;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getEnumListObjects = createAsyncThunk(
	"stepThreeSlice/getEnumListObjects",
	async (
		{
			enumListId,
			part,
			quantity,
			setLoad,
		}: { enumListId: number; part: number; quantity: number; setLoad?: () => void },
		{ rejectWithValue },
	) => {
		try {
			const response = await kiiEnumsAPI
				.enumObjsDetail(enumListId, {
					offset: part,
					limit: quantity,
					short_info: false,
				})
				.then((r) => r.data);
			// const response = (
			// 	await $api<any[]>(`/kii_enums/${enumListId}/enum_objs?offset=${part}&limit=${quantity}&short_info=${false}`)
			// ).data;
			if (setLoad) setLoad();
			return { response, quantity };
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getEnumListObjectsShort = createAsyncThunk(
	"stepThreeSlice/getEnumListObjectsShort",
	async ({ enumListId }: { enumListId: number }, { rejectWithValue }) => {
		try {
			return await kiiEnumsAPI.enumObjsDetail(enumListId, { short_info: true }).then((r) => r.data);
			// return (await $api<any[]>(`/kii_enums/${enumListId}/enum_objs?short_info=${true}`)).data;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

// готов
export const createAddition = createAsyncThunk(
	"stepThreeSlice/createAddition",
	async (
		{
			organizationId,
			listName,
			selectionList,
			close,
		}: { organizationId: number; listName: string; selectionList: any[]; close: () => void },
		{ rejectWithValue },
	) => {
		try {
			const selectionListId: number[] = selectionList.map((object: any) => object.id);
			const newEnumList = await kiiEnumsAPI.addAdditionalEnumListCreate(organizationId, listName).then((r) => r.data);
			// const newEnumList = (await $api.post(`/kii_enums/${organizationId}/add_additional_enum_list`, listName)).data;
			const newEnumListObjects = await kiiEnumsAPI
				.addObjlistToEnumListCreate(newEnumList.id, selectionListId)
				.then((r) => r.data);
			// const newEnumListObjects = (
			// 	await $api.post(`/kii_enums/${newEnumList.id}/add_objlist_to_enum_list`, selectionListId)
			// ).data;
			close();
			return { newEnumList, newEnumListObjects };
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const changeComposition = createAsyncThunk(
	"stepThreeSlice/changeComposition",
	async (
		{
			deletingList,
			addingList,
			enumListId,
			close,
			deactivateStatus,
		}: {
			deletingList: number[];
			addingList: number[];
			enumListId: number;
			close: () => void;
			deactivateStatus: () => void;
		},
		{ rejectWithValue },
	) => {
		try {
			// let deletionResult = null;
			// let addingResult = null;
			if (deletingList.length) {
				// то, что осталось после запроса
				await kiiEnumsAPI.deleteCreate(deletingList);
				// deletionResult = (await $api.post<any[]>(`/kii_enums/delete`, deletingList)).data;
			}
			if (addingList.length) {
				// то, что осталось после запроса
				await kiiEnumsAPI.addObjlistToEnumListCreate(enumListId, addingList);
				// addingResult = (await $api.post<any[]>(`/kii_enums/${enumListId}/add_objlist_to_enum_list`, addingList)).data;
			}
			const response = await kiiEnumsAPI
				.enumObjsDetail(enumListId, {
					offset: 1,
					limit: PAGINATION_COUNT_STEP_THREE,
					short_info: false,
				})
				.then((r) => r.data);
			// const response = (
			// 	await $api<any[]>(
			// 		`/kii_enums/${enumListId}/enum_objs?offset=${1}&limit=${PAGINATION_COUNT_STEP_THREE}&short_info=${false}`,
			// 	)
			// ).data;
			close();
			deactivateStatus();
			return response;
		} catch ({ message }) {
			close();
			return rejectWithValue(message);
		}
	},
);

export const dowloadDocument = createAsyncThunk(
	"stepThreeSlice/dowloadDocument",
	async (
		{
			enumListId,
			fileName,
			setIsPending,
		}: { enumListId: number; fileName: string; setIsPending: (value: boolean) => void },
		{ rejectWithValue },
	) => {
		let interval: any;
		interval = setInterval(async () => {
			try {
				const documentId = await kiiEnumsAPI.docsGetDocxIdsDetail(enumListId).then((r) => r.data);
				// const documentId = (await $api(`/kii_enums/docs/${enumListId}/get_docx_ids`)).data;
				if (documentId) {
					clearInterval(interval);
					setIsPending(false);
					return await kiiEnumsAPI.docsDetail(documentId, { format: "blob" }).then((response) => {
						const href = URL.createObjectURL(response.data);
						const link = document.createElement("a");
						link.href = href;
						link.setAttribute("download", `${fileName}.docx`); //or any other extension
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						URL.revokeObjectURL(href);
					});
					// return $api({
					// 	url: `/kii_enums/docs/${documentId}`, //your url
					// 	method: "GET",
					// 	responseType: "blob", // important
					// }).then((response) => {
					// 	const href = URL.createObjectURL(response.data);
					// 	const link = document.createElement("a");
					// 	link.href = href;
					// 	link.setAttribute("download", `${fileName}.docx`); //or any other extension
					// 	document.body.appendChild(link);
					// 	link.click();
					// 	document.body.removeChild(link);
					// 	URL.revokeObjectURL(href);
					// });
				}
			} catch (e) {
				setIsPending(false);
				clearInterval(interval);
				return;
			}
		}, 2000);
	},
);

export const uploadDocument = createAsyncThunk(
	"stepThreeSlice/uploadDocument",
	async (
		{
			enumListId,
			file,
			userName,
			setIsPending,
			toClear,
		}: { enumListId: number; file: any; userName: string; setIsPending: (value: boolean) => void; toClear: () => void },
		{ rejectWithValue },
	) => {
		// const params = new FormData();
		// params.append("file", file);
		try {
			const documentId = await kiiEnumsAPI.docsGetDocxIdsDetail(enumListId).then((r) => r.data);
			// const documentId = (await $api(`/kii_enums/docs/${enumListId}/get_docx_ids`)).data;
			if (documentId) {
				await kiiEnumsAPI.docsUploadCreate(documentId, {
					ApprovedDoc: file,
				});
				// await $api.post<any>(`/kii_enums/docs/${documentId}/upload`, params);
				setIsPending(false);
				toClear();
				return userName;
			}
		} catch ({ message }) {
			setIsPending(false);
			toClear();
			return rejectWithValue(message);
		}
	},
);

export const printDocument = createAsyncThunk(
	"stepThreeSlice/printDocument",
	async (
		{
			enumListId,
			fileName,
			setIsPending,
		}: { enumListId: number; fileName: string; setIsPending: (value: boolean) => void },
		{ rejectWithValue },
	) => {
		let interval: any;
		interval = setInterval(async () => {
			try {
				const documentId = await kiiEnumsAPI.docsGetDocxIdsDetail(enumListId).then((r) => r.data);
				// const documentId = (await $api(`/kii_enums/docs/${enumListId}/get_docx_ids`)).data;
				if (documentId) {
					clearInterval(interval);
					setIsPending(false);
					const documentURL = await kiiEnumsAPI.docsLinkDetail(documentId, "pdf").then((r) => r.data);
					// const documentURL = (await $api(`/kii_enums/docs/${documentId}/pdf/link`)).data;
					// logging
					await kiiEnumsAPI.docsTouchDetail(documentId, { action: "PRINT" });
					// await $api.get(`/kii_enums/docs/${documentId}/touch?action=PRINT`);

					return $api({
						url: `${documentURL}`, //your url
						method: "GET",
						responseType: "blob", // important
					}).then(async (response: any) => {
						const clear = (frame: HTMLIFrameElement) => {
							frame.remove();
						};
						let blob = new Blob([response.data], { type: response.data.type }); //this make the magic
						let blobURL = URL.createObjectURL(blob);
						const frames = document.querySelectorAll("iframe");
						frames.forEach((_) => {
							clear(_);
						});
						let iframe: HTMLIFrameElement = document.createElement("iframe"); //load content in an iframe to print later
						document.body.appendChild(iframe);
						iframe.style.display = "none";
						iframe.src = blobURL;
						iframe.onload = function () {
							setTimeout(function () {
								iframe.focus();
								iframe.contentWindow!.print();
							}, 1);
						};
					});
				}
			} catch (e) {
				setIsPending(false);
				clearInterval(interval);
				return;
			}
		}, 2000);
	},
);

export const deleteAddition = createAsyncThunk(
	"stepThreeSlice/deleteAddition",
	async ({ enumListId }: { enumListId: number }, { rejectWithValue }) => {
		try {
			await kiiEnumsAPI.deleteEnumListCreate(enumListId);
			// await $api.post<any[]>(`/kii_enums/${enumListId}/delete_enum_list`);
			return enumListId;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const changeEnumListName = createAsyncThunk(
	"stepThreeSlice/changeEnumListName",
	async ({ enumListId, newName }: { enumListId: number; newName: string }, { rejectWithValue }) => {
		try {
			await kiiEnumsAPI.setListNameCreate(enumListId, newName);
			// await $api.post<any[]>(`/kii_enums/${enumListId}/set_list_name`, newName);
			return newName;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);
